import { Provinces } from './provinces';

const BaiProvinces: Array<keyof Provinces> = ['ES-VI', 'ES-BI', 'ES-SS'];

export default BaiProvinces;
